<ng-container *transloco="let t">
  <div class="breadcrumbs">
    @for(link of breadcrumbsContent; track link;let idx = $index){
    <span (click)="navigateToBreadcrumbLink(idx)" class="breadcrumbs__link"
      [ngClass]="{'last' : breadcrumbsContent.indexOf(link)===breadcrumbsContent.length-1}">
      {{t(link.name)}}
    </span>
    }
  </div>
</ng-container>